// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickLinksCard_ql__GQZNB {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-primary-3);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
}
.QuickLinksCard_ql__title__WMSzo {
  padding: 0;
  margin: 0;
  font-size: var(--default-font-size);
  font-weight: 700;
  margin-bottom: 3rem;
}
.QuickLinksCard_ql__content__QKbvt {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  margin: 2rem 0 2rem 0;
}
.QuickLinksCard_ql__content__QKbvt > :not(:last-child) {
  margin-bottom: 2rem;
}
@media only screen and (max-width: 50em) {
  .QuickLinksCard_ql__content__QKbvt > :not(:last-child) {
    margin-bottom: 4rem;
  }
}
.QuickLinksCard_ql__link__Hg6zh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.QuickLinksCard_ql__link__Hg6zh:hover {
  color: var(--color-primary-2);
  font-weight: 700;
}
.QuickLinksCard_ql__link__Hg6zh p {
  margin: 0;
  padding: 0;
}
.QuickLinksCard_ql__icon__JDxle {
  font-size: 2.2rem;
}

.QuickLinksCard_reference__kZm-G {
  display: flex;
  background-color: var(--color-dark);
  border-radius: 1rem;
  padding: 2rem;
  color: var(--color-white);
  gap: 2rem;
  width: 100%;
  margin-bottom: 2rem;
  font-size: var(--default-font-small);
}
@media only screen and (max-width: 43.75em) {
  .QuickLinksCard_reference__kZm-G {
    flex-direction: column;
    width: 100%;
  }
}
.QuickLinksCard_reference__copy__jcUb0 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  color: var(--color-dark);
  cursor: pointer;
  border-radius: 0.5rem;
  align-items: center;
  background-color: var(--color-white);
  padding: 1rem;
  width: 100%;
  gap: 2rem;
}
.QuickLinksCard_reference__copy__jcUb0:hover {
  transition: 0.5s;
  background-color: var(--color-light-grey);
}
.QuickLinksCard_reference__copy__icon__XYZHv {
  font-size: 3.2rem;
}
.QuickLinksCard_reference__link__VgLCp {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/QuickLinksCard.module.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,mBAAA;EACA,wCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AADD;AAGC;EACC,UAAA;EACA,SAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;AADF;AAIC;EACC,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;AAFF;AAIE;EACC,mBAAA;AAFH;AAGG;EAFD;IAGE,mBAAA;EAAF;AACF;AAIC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAFF;AAIE;EACC,6BAAA;EACA,gBAAA;AAFH;AAKE;EACC,SAAA;EACA,UAAA;AAHH;AAOC;EACC,iBAAA;AALF;;AASA;EACC,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;AAND;AAQC;EAXD;IAYE,sBAAA;IACA,WAAA;EALA;AACF;AAOC;EACC,aAAA;EACA,8BAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;AALF;AAOE;EACC,gBAAA;EACA,yCAAA;AALH;AAQE;EACC,iBAAA;AANH;AAUC;EACC,WAAA;AARF","sourcesContent":["@import '../variables/breakpoints';\n\n.ql {\n\twidth: 100%;\n\tborder-radius: 2rem;\n\tbackground-color: var(--color-primary-3);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tbox-sizing: border-box;\n\tpadding: 3.5rem 2rem;\n\n\t&__title {\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tfont-size: var(--default-font-size);\n\t\tfont-weight: 700;\n\t\tmargin-bottom: 3rem;\n\t}\n\n\t&__content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-evenly;\n\t\tbox-sizing: border-box;\n\t\tmargin: 2rem 0 2rem 0;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 2rem;\n\t\t\t@media only screen and (max-width: $bp-medium) {\n\t\t\t\tmargin-bottom: 4rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__link {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary-2);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tp {\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t&__icon {\n\t\tfont-size: 2.2rem;\n\t}\n}\n\n.reference {\n\tdisplay: flex;\n\tbackground-color: var(--color-dark);\n\tborder-radius: 1rem;\n\tpadding: 2rem;\n\tcolor: var(--color-white);\n\tgap: 2rem;\n\twidth: 100%;\n\tmargin-bottom: 2rem;\n\tfont-size: var(--default-font-small);\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t}\n\n\t&__copy {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: wrap;\n\t\tcolor: var(--color-dark);\n\t\tcursor: pointer;\n\t\tborder-radius: 0.5rem;\n\t\talign-items: center;\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 1rem;\n\t\twidth: 100%;\n\t\tgap: 2rem;\n\n\t\t&:hover {\n\t\t\ttransition: 0.5s;\n\t\t\tbackground-color: var(--color-light-grey);\n\t\t}\n\n\t\t&__icon {\n\t\t\tfont-size: 3.2rem;\n\t\t}\n\t}\n\n\t&__link {\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ql": `QuickLinksCard_ql__GQZNB`,
	"ql__title": `QuickLinksCard_ql__title__WMSzo`,
	"ql__content": `QuickLinksCard_ql__content__QKbvt`,
	"ql__link": `QuickLinksCard_ql__link__Hg6zh`,
	"ql__icon": `QuickLinksCard_ql__icon__JDxle`,
	"reference": `QuickLinksCard_reference__kZm-G`,
	"reference__copy": `QuickLinksCard_reference__copy__jcUb0`,
	"reference__copy__icon": `QuickLinksCard_reference__copy__icon__XYZHv`,
	"reference__link": `QuickLinksCard_reference__link__VgLCp`
};
export default ___CSS_LOADER_EXPORT___;
